<template>
  <div class="container is-fullwidth">
    <div class="columns">
      <div class="column is-4 is-offset-1">
        <div class="title has-text-centered">Find Mentor</div>

        <table class="table has-background-light search-options">
          <tbody>
            <tr>
              <td class="is-vcentered is-fullheight">
                <label class="label">Search key</label>
              </td>
              <td class="is-vcentered is-fullheight">
                <div class="control is-fullwidth">
                  <input
                    v-model="search_text"
                    class="input"
                    type="text"
                    placeholder="Enter username or name..."
                  />
                </div>
              </td>
            </tr>

            <tr>
              <td class="is-vcentered is-fullheight">
                <label class="label">Type Of Mentor</label>
              </td>
              <td class="is-vcentered is-fullheight">
                <div class="select is-fullwidth">
                  <select v-model="selected_uid.designation">
                    <option value="" selected="selected">
                      Any designation
                    </option>
                    <option
                      v-for="designation in field_options.designation"
                      v-bind:key="designation.uid"
                      v-bind:value="designation.uid"
                    >
                      {{ designation.label }}
                    </option>
                  </select>
                </div>
              </td>
            </tr>

            <!-- <tr>
              <td class="is-vcentered is-fullheight">
                <label class="label">Department</label>
              </td>
              <td class="is-vcentered is-fullheight">
                <div class="select is-fullwidth">
                  <select v-model="selected_uid.department">
                    <option value="" selected="selected">Any department</option>
                    <option
                      v-for="department in field_options.department"
                      v-bind:key="department.uid"
                      v-bind:value="department.uid"
                    >
                      {{ department.label }}
                    </option>
                  </select>
                </div>
              </td>
            </tr> -->

            <tr>
              <td class="is-vcentered is-fullheight">
                <label class="label">Area Of Work</label>
              </td>
              <td class="is-vcentered is-fullheight">
                <div class="select is-fullwidth">
                  <select v-model="selected_uid.discipline">
                    <option value="" selected="selected">Any discipline</option>
                    <option
                      v-for="discipline in field_options.discipline"
                      v-bind:key="discipline.uid"
                      v-bind:value="discipline.uid"
                    >
                      {{ discipline.label }}
                    </option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="is-centered">
                <button
                  class="button is-primary is-fullwidth"
                  v-on:click="find_mentors"
                >
                  Search
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- SEARCH RESULTS -->
      <div class="column is-offset-1 is-5">
        <div class="title has-text-centered">Search Results</div>

        <div v-if="search_results.length === 0">
          <span
            class="box is-centered has-text-centered has-text-weight-bold has-background-white"
          >
            No data
          </span>
        </div>
        <div
          v-else
          class="px-3"
          style="max-height: min(600px, 60vh); overflow-y: auto"
        >
          <ul>
            <li
              v-for="(mentor, index) in search_results"
              class="box py-4 my-3"
              v-bind:key="index"
            >
              <div class="columns is-mobile is-vcentered">
                <div class="column">
                  <router-link
                    v-bind:to="{
                      name: 'MentorProfilePage',
                      params: { profile_uid: mentor.uid },
                    }"
                    class="hyperlink"
                  >
                    {{ mentor.first_name }} {{ mentor.last_name }}
                  </router-link>

                  <div class="is-italic">
                    <!-- {{ mentor.designation_label }}, -->
                    <ul>
                      <li v-for="item in mentor.discipline_label">
                        {{ item.label }}
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="column is-narrow">
                  <button
                    v-on:click="openModal(index)"
                    class="button is-primary"
                  >
                    Request
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- SEND REQUEST MODAL -->
      <div
        v-bind:class="{ 'is-active': show_send_request_modal }"
        class="modal"
      >
        <div
          class="modal-background"
          v-on:click="clear_and_close_send_request_modal"
        ></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Send Request</p>
            <button
              v-on:click="clear_and_close_send_request_modal"
              class="delete"
              aria-label="close"
            ></button>
          </header>

          <section class="modal-card-body">
            <InputBox
              input_type="textarea"
              v-model="modal.statement_of_purpose"
              v-bind:errors="modal_errors.statement_of_purpose"
              label="Statement of Purpose"
            />

            <InputBox
              input_type="number"
              v-model="modal.commitment"
              v-bind:errors="modal_errors.commitment"
              label="Commitment (Seeking mentorships for so many months)"
            />

            <InputBox
              input_type="textarea"
              v-model="modal.expectations"
              v-bind:errors="modal_errors.expectations"
              label="Expectations from mentorship"
            />

					<!-- <InputBox input_type="textarea" v-model="modal.expectations" v-bind:errors="modal_errors.expectations"
							  label="Expectations" /> -->

					<div class="container">
						<ul>
              <div v-if = "mentee_profile.researches.length">
                <label class="label">Select Researches</label>
              </div>
              <li v-for="research in mentee_profile.researches" class="pb-2">
                <label class="checkbox pb-2">
                  <input type="checkbox"
                       v-bind:key="research.uid"
                       v-bind:value="research.uid"
                       v-model="modal.researches">
                  {{ research.title }} <span style="text-transform: capitalize;"> ({{ research.category.replace('_', ' ') }}) </span>
                </label>
              </li>
						</ul>
						<ul>
              <div v-if = mentee_profile.achievements.length>
                <label class="label">Select Achievements</label>
              </div>
              <li v-for="achievement in mentee_profile.achievements" class="pb-2">
                <label class="checkbox pb-2">
                  <input type="checkbox"
                        v-on:click="select_value"
                        v-bind:key="achievement.uid"
                        v-bind:value="achievement.uid"
                        v-model="modal.achievements">
                  {{ achievement.title }}
                </label>
              </li>
						</ul>
					</div>
            <label class="label">Requirement Specified By Mentor</label>
            <p class="mb-2">Select all that apply:</p>
            <div v-if="showLoading">
              <i class="fas fa-spinner fa-pulse"></i>
            </div>
            <ul
              v-else-if="
                search_results[selected_mentor_index] && search_results[selected_mentor_index].priorities.length > 0
              "
            >
              <li
                v-for="priority in search_results[selected_mentor_index].priorities"
                v-bind:key="priority.uid"
              >
                <!-- <label class="checkbox pb-2"> -->
                <label>
                  <input
                    type="checkbox"
                    v-bind:key="priority.uid"
                    v-bind:value="priority.uid"
                    v-model="modal.checklist"
                  />
                  {{ priority.label }}
                  <span
                    v-bind:class="{
                      'is-danger': priority.priority === 2,
                      'is-warning': priority.priority === 1,
                      'is-success': priority.priority === 0,
                    }"
                    class="tag is-light ml-2"
                  >
                    {{ PRIORITY_VALUES[priority.priority] }}
                  </span>
                </label>
              </li>
            </ul>
            <div v-else>This mentor has not set any requirements.</div>
            <div v-if="search_results[selected_mentor_index] && search_results[selected_mentor_index].projects && !isEmpty(search_results[selected_mentor_index].projects)">
              <label class="label">Select Project in which you want mentorship</label>
              <div class="columns my-3 mx-1 select is-fullwidth">
                <select v-model="modal.project_uid" v-on:change="select_project(selected_mentor_index)">
                  <option value="select" selected disabled>--Select--</option>
                  <option
                    v-for="(project, index) in search_results[selected_mentor_index].projects"
                    v-bind:value="project.uid"
                    v-bind:key="index"
                  >
                    {{ project.title }}
                  </option>
                </select>
              </div>
              <div class="box p-3" v-if="project_title">
                <p>
                  <span style="font-weight: bolder;">Title: </span> {{ project_title }}
                  <br>
                  <span style="font-weight: bolder;">Details: </span> {{ project_details }}
                </p>
                <p>
                  <span style="font-weight: bolder;" v-if="test_details">Test or assignment Details:</span> {{ test_details }}
                  <br>
                  {{ test_file_name }} 
                  <br>
                  <button class="button is-responsive is-primary" v-if="test_file_name" v-on:click="download_file(test_file_name)">Download</button>
                </p>
                <span style="font-weight: bolder;" v-if="test_details || test_file_name">Submit test solution file:
                  <input type="file" name="" id="test_file" v-on:change="handleFile" ref="file" required>
                </span>
              </div>
            </div>
          </section>

          <footer class="modal-card-foot">
            <div class="columns is-mobile" style="width: 100%">
              <div class="column has-text-right">
                <button
                  v-on:click="send_mentorship_request"
                  class="button is-success"
                >
                  Send
                </button>
                <button
                  v-on:click="clear_and_close_send_request_modal"
                  class="button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios, { API_URL } from '../../api/my-axios';
import InputBox from '../../components/FormHelpers/InputBox';
import FormErrors from '../../components/FormHelpers/FormErrors';
import { mapState } from 'vuex';
import { PRIORITY_VALUES } from '../../lib';

export default {
  components: {
    FormErrors,
    InputBox,
  },
  computed: {
    ...mapState({
      user: 'user',
    }),
  },
  data() {
    return {
      selected_checklist: [],
      PRIORITY_VALUES,
      search_text: '',
      field_options: {
        designation: [],
        // department: [],
        discipline: [],
      },

      selected_uid: {
        designation: '',
        department: '',
        discipline: '',
      },
      mentee_profile: {
				researches: [],
				achievements: [],
			},
      show_send_request_modal: false,
      modal: {
        statement_of_purpose: "",
				commitment: "",
				expectations: "",
				researches: [],
				achievements: [],
        checklist: [],
        project_uid: "",
        file: null,
      },
      project_title: "",
      project_details: "",
      test_details: "",
      test_file_name: "",
      selected_mentor_index: -1,
      search_results: [], // TODO Should only consist of non-pending requests

      modal_errors: {},
      showLoading: true,
    };
  },
  created() {
    // TODO Try to fetch all three field options in one-go
    this.get_field_options();
    this.find_mentee_research();
		this.find_mentee_achievement();
  },
  methods: {
    find(uid) {
      for (let i = 0; i < this.selected_checklist.length; i++) {
        if (this.selected_checklist[i] == uid) {
          return true;
        }
      }
      return false;
    },
    select_value(val) {
      console.log(val);
      this.selected_checklist.push(val);
    },
    openModal(index) {
      this.show_send_request_modal = true;
      this.selected_mentor_index = index;
      this.showLoading = true;
      this.project_details = "";
      this.project_title = "";
      this.test_details = "";
      this.test_file_name = "";
      axios
        .get(`/api/mentor/checklist/?mentor=${this.search_results[index].uid}`)
        .then((response) => {
          this.search_results[index].priorities = response.data;
          this.search_results.forEach((mentor) => {
            mentor.priorities.sort((a, b) =>
              a.priority > b.priority ? -1 : 1
            );
          });
          this.showLoading = false;
        });
        axios
        .get(`/api/mentor/project/?mentor=${this.search_results[index].uid}`)
        .then((response) => {
          var projects = {};
          response.data.forEach((project) => {
            projects[project.uid] = project;
          });
          this.search_results[index].projects = projects;
          this.showLoading = false;
        });
    },

    clear_send_request_modal() {
      for (const key in this.modal) {
        if(key === "checklist" || key === "researches" || key === "achievements"){
          this.modal[key] = [];
        }
        else{ 
          this.modal[key] = '';
        }
      }

      this.modal_errors = {};
      this.selected_mentor_index = -1;
    },

    clear_and_close_send_request_modal() {
      this.clear_send_request_modal();
      this.show_send_request_modal = false;
    },

    handleFile(){
      this.modal.file = this.$refs.file.files[0];
    },

    select_project(index)
    {
      // console.log(this.modal.project_uid);
      var project = this.search_results[index].projects[this.modal.project_uid];
      this.project_title = project.title;
      this.project_details = project.details;
      this.test_details = project.test_details;
      this.test_file_name = project.test_file_name;
    },

    download_file(file_name){
      console.log(API_URL)
      var url = API_URL+ 'media/tests_files/'+file_name;
      window.open(url, '_blank');
    },

    get_field_options() {
      for (const field in this.field_options) {
        axios
          .get(`/api/mentor/${field}/`)
          .then((response) => {
            this.field_options[field] = response.data;
          })
          .catch((error) => {
            this.errors = error.response.data;
          });
      }
    },

    find_mentee_research() {
			
			axios
				.get(`/api/mentee/research/`, {
					params: {
						mentee: this.user.profile_uid,
					}
				})
				.then(response => {
					this.mentee_profile['researches'] = response.data;
				})
				.catch(error => {
					console.error(error);
				});
		},
    find_mentee_achievement() {
			axios
				.get(`/api/mentee/achievement/`, {
					params: {
						mentee: this.user.profile_uid,
					}
				})
				.then(response => {
					this.mentee_profile['achievements'] = response.data;
				})
				.catch(error => {
					console.error(error);
				});
		},
    
    find_mentors() {
      axios
        .get('/api/mentor/mentor/find_for_mentorship/', {
          params: {
            search: this.search_text,
            designation: this.selected_uid.designation,
            department: this.selected_uid.department,
            discipline: this.selected_uid.discipline,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.search_results = response.data;
        })
        .catch((error) => {
          console.error(error);
          this.errors = error.response
            ? error.response.data
            : { detail: [error.message] };
        });
    },

    isEmpty(obj) {
      for (var prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
          return false;
        }
      }
      return true
    },

    send_mentorship_request() {
      console.log("sending this =" + this.model)
      const headers = { 'Content-Type': 'multipart/form-data' };
      const formdata = new FormData();
      formdata.append('mentee', this.user.profile_uid)
      formdata.append('mentor', this.search_results[this.selected_mentor_index].uid)
      formdata.append('project', this.modal.project_uid)
      formdata.append('statement_of_purpose', this.modal.statement_of_purpose)
      formdata.append('commitment', this.modal.commitment)
      formdata.append('expectations', this.modal.expectations)
      if (this.modal.file){
        formdata.append('file', this.modal.file)
      }
      if(this.modal.researches.length > 0){
        this.modal.researches.forEach((item) => formdata.append("researches", item))

        // formdata.append('researches', JSON.stringify(this.modal.researches))
      }
      if(this.modal.checklist.length > 0){
        this.modal.checklist.forEach((item) => formdata.append("checklist", item))
        // formdata.append('checklist', JSON.stringify(this.modal.checklist))
      }
      if(this.modal.achievements.length > 0){
        this.modal.achievements.forEach((item) => formdata.append("achievements", item))
        // formdata.append('achievements', JSON.stringify(this.modal.achievements))
      }
      axios
        .post('/api/mentorship/request/', formdata, {headers})
        .then((_) => {
          delete this.search_results[this.selected_mentor_index].projects[this.modal.project_uid]
          if (this.isEmpty(this.search_results[this.selected_mentor_index].projects)){
            this.search_results.splice(this.selected_mentor_index, 1);
          }
          this.clear_and_close_send_request_modal();
        })
        .catch((error) => {
          this.modal_errors = error.response.data;
        });
    },
  },
};
</script>

<style scoped>
.search-results td,
.search-options td {
  border: none !important;
}
</style>
